import React, { useMemo } from "react";

import ConnectionStatusView from "./ConnectionStatusView";
import { ConnectionState } from "@/features/knowledge-graph/types";

import { env } from "@/lib/env";
import { ConnectionStatus as ConnectionStatusType } from "@/stores/knowledgeGraph";

/**
 * Props for ConnectionStatusContainer
 */
interface ConnectionStatusContainerProps {
  connectionState: ConnectionStatusType | ConnectionState;
  reconnectAttempts?: number;
}

/**
 * Container component for SSE connection status display
 * @param root0 - Component props
 * @param root0.connectionState - Current SSE connection state (connecting, connected, disconnected, error)
 * @param root0.reconnectAttempts - Number of reconnection attempts made (optional, defaults to 0)
 */
const ConnectionStatusContainer: React.FC<ConnectionStatusContainerProps> = ({
  connectionState,
  reconnectAttempts = 0,
}) => {
  const endpoint = env.EXPO_PUBLIC_SSE_ENDPOINT || "";
  const isPlaceholder = endpoint.includes("your-sse-endpoint");

  // Handle both enum and string types
  const displayState = useMemo(() => {
    // Convert to string and lowercase
    const stateStr =
      typeof connectionState === "string"
        ? connectionState
        : String(connectionState);
    return stateStr.toLowerCase();
  }, [connectionState]);

  return (
    <ConnectionStatusView
      isPlaceholder={isPlaceholder}
      displayState={displayState}
      reconnectAttempts={reconnectAttempts}
    />
  );
};

export const ConnectionStatus = React.memo(ConnectionStatusContainer);

export default ConnectionStatusContainer;
